export const APP_VERSION = {
  version: process.env.REACT_APP_BUILD_VERSION || "dev-local",
  commitSha: process.env.REACT_APP_COMMIT_SHA || "unknown",
  buildTime: process.env.REACT_APP_BUILD_TIME || "unknown",
};

export const getVersionLabel = (versionInfo = APP_VERSION) => {
  const shortSha =
    versionInfo.commitSha && versionInfo.commitSha.length > 8
      ? versionInfo.commitSha.substring(0, 8)
      : versionInfo.commitSha;

  return `${versionInfo.version}${shortSha ? ` (${shortSha})` : ""}`;
};
